import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentsService } from '../services/documents.service';
@Component({
  selector: 'app-document-image',
  templateUrl: './document-image.component.html',
  styleUrls: ['./document-image.component.css']
})
export class DocumentImageComponent implements OnInit {
  public doc;
  constructor(
     private dialogRef: MatDialogRef<DocumentImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _documentsService : DocumentsService
    
) { 
}
  closer():void{
    this.dialogRef.close();
  }
  ngOnInit() {
    this.doc = this._documentsService.doc;
  }

}
